import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { loginConstants, configurationsConstants } from "../../../constants";
import { getDecryptPayload } from "../../../system";
import InputField from "../../../shared/components/Fields/InputField";
import { loginActions } from "../../../redux/actions";

const ChangePasswordForm = (props) => {
  const { t } = useTranslation("common");

  const payload = getDecryptPayload();
  const userName = (payload.user && payload.user.userName) || "";

  const [isPasswordSame, setIsPasswordSame] = useState(true);

  const loginSpinner = useMemo(
    () => props.spinnerActions.findIndex((f) => f === loginConstants.LOGIN),
    [props.spinnerActions]
  );

  // when user clicks on change password button.
  const handleSubmit = (event, values) => {
    if (values.password !== values.confirmPassword) {
      setIsPasswordSame(false);
      return;
    } else {
      setIsPasswordSame(true);
    }

    const id = props.authentication.userId;
    props.changePassword({ id, ...values });
  };

  return (
    <div className="event-setup-form-box mb-2 m-6">
      <h4 className="text-center shutterb-form-header mb-5">
        {t("create_or_change_password")}
      </h4>
      <AvForm id="change-password-form" onValidSubmit={handleSubmit} noValidate autoComplete="off">
        <div id="form-content">
          <div className="row">
            <div className="col-lg-12">
              <AvField
                name="userName"
                label={
                  <span className="label-content-600">{t("user_email")}</span>
                }
                value={userName}
                type="text"
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <InputField
                label={
                  <span className="form-label label-content-600">Password</span>
                }
                required
                type="password"
                name="password"
                placeholder="Password"
                maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).{6,}$"
                errorMessage="minimum 6 characters, including number, special, lower & uppercase characters are required"
                patternErrorMessage="minimum 6 characters, including number, special, lower & uppercase characters are required"
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <InputField
                required
                type="password"
                name="confirmPassword"
                label={
                  <span className="form-label label-content-600">
                    Confirm Password
                  </span>
                }
                placeholder="Confirm Password"
                maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                pattern=""
                errorMessage={t("this_field_is_required")}
                onChange={() => {
                  !isPasswordSame && setIsPasswordSame(true);
                }}
              />
              {!isPasswordSame && (
                <p className="custom-error p-0 m-0">
                  password & confirm password does not match.
                </p>
              )}
            </div>
          </div>
          <div className="row justify-content-center pt-4">
            <div className="event-booking-form-btn">
              {loginSpinner > -1 ? (
                <div className=" account__btn text-center login_spinner">
                  <LoadingIcon fill="#70bbfd" />
                </div>
              ) : (
                <button type="submit" className="custom-btn">
                  {t("submit")}
                </button>
              )}
            </div>
          </div>
        </div>
      </AvForm>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  authentication: state.authentication,
  spinnerActions: state.system.spinnerActions,
  shutterbAuthentication: state.shutterbAuthentication,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(loginActions.logout()),
  changePassword: (data) => dispatch(loginActions.changePassword(data)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ChangePasswordForm));
